import { render, staticRenderFns } from "./PeopleTodayLogBarCharttool.vue?vue&type=template&id=80d9b32a"
import script from "./PeopleTodayLogBarCharttool.vue?vue&type=script&lang=js"
export * from "./PeopleTodayLogBarCharttool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports